<app-modal-container>
  <div class="confirm-modal">
    <h2 class="confirm-modal__title">{{ title }}</h2>
    <p class="confirm-modal__message">{{ message }}</p>
    <div class="confirm-modal__actions">
      <kin-btn color="danger" (onClick)="onCancel()">{{ cancelText }}</kin-btn>
      <kin-btn (onClick)="onConfirm()">{{ confirmText }}</kin-btn>
    </div>
  </div>
</app-modal-container>
